<div class="flex flex-row items-center w-full justify-between">
  <p>{{ '+INSTALLATIONS.INSTALLATION.PANEL.CIRCUIT' | translate }} {{ circuitId }}</p>
  <mat-slide-toggle
    #ecoControlToggle
    gtm="onToggle"
    gtmAction="OBNG smart pump control toggle"
    gtmCategory="singleRoomControl"
    [disabled]="!ecoControl?.commands?.setActive?.isExecutable"
    [checked]="ecoControl?.properties?.active?.value"
    (change)="onToggleChange(ecoControlToggle)"
  ></mat-slide-toggle>
</div>
